import { useEffect } from 'react'
import type { InfiniteData } from '@tanstack/react-query'
import {
  getBetLoopFeedPostsRemovedTopic,
  isFollowMeFeedPostRemovePayload,
  iotSubscribeTopics,
  iotUnsubscribeTopics,
} from '@core/State/PushData'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import type { BetLoopSharedBet } from '@core/Areas/BetLoop/types'

export function useSharedBetsTopicSubscription() {
  useEffect(() => {
    const topic = getBetLoopFeedPostsRemovedTopic()

    const subscription = iotSubscribeTopics([topic]).subscribe(data => {
      if (!isFollowMeFeedPostRemovePayload(data.payload)) return
      const postId = Number(data.payload.postId)
      if (!postId) return

      queryClient.setQueriesData<InfiniteData<BetLoopSharedBet[]>>(
        { queryKey: queryKeys.betLoopSharedBetsFeedBase() },
        currentCachedData => updateSharedBetStatus(postId)(currentCachedData)
      )
    })

    return () => {
      subscription.dispose()
      iotUnsubscribeTopics([topic])
    }
  }, [])
}

// =============
// Local Helpers
// =============

const updateSharedBetStatus =
  (ids: BetLoopSharedBet['postId'] | BetLoopSharedBet['postId'][]) =>
  (
    currentCachedData: InfiniteData<BetLoopSharedBet[]> | undefined
  ): InfiniteData<BetLoopSharedBet[]> | undefined => {
    if (!currentCachedData) return currentCachedData

    const postIdSet = new Set(Array.isArray(ids) ? ids : [ids])

    return {
      ...currentCachedData,
      pages: currentCachedData.pages.map(page =>
        page.map(bet =>
          postIdSet.has(Number(bet.postId))
            ? { ...bet, ticket: { ...bet.ticket, status: 'BettingClosed' } }
            : bet
        )
      ),
    }
  }
